import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    OtpContainer: {
        display: 'flex',
        columnGap: '8px'
    },
    OtpInput: {
        width: '56px',
        height: '56px',
        '& > div': {
            height: '100%'
        },
        '& input': {
            textAlign: 'center'
        }
    },
    SmallInputs: {
        height: '36px',
        width: '36px'
    }
}));
//# sourceMappingURL=styles.js.map